import * as types from '@/store/mutation-types';

const state = {
    availableTrackings: {
        'habiteo': false,
        'google': false
    },
    cookieDisclaimer: {
        'opened': false
    },
    hasGPDRConsent: false,
    isAlternativeMode: null,
    isInternal: false,
    isIframe: false,
    isCookiesEnabled: false,
    isLocalstorageAvailable: false,
    isLoading: false,
    isOfflineMode: null,
    isOnline: null,
    isReviewUse: false,
    language: null,
    logos: null,
    loadingBackground: null,
    protocol: null,
    programInfo: null,
    route: null,
    snackbar: null,
    startedWidget: null,
    disableCloseSidebar: false,
    hasSidebar: null,
    resolution: "720p",
};

const mutations = {
    [types.SET_ROUTE](state, route) {
        state.route = route;
        state.isAlternativeMode = state.startedWidget !== 'program' && 'alternative' in route.query;
        state.isOfflineMode = state.startedWidget === 'program' && 'offline' in route.query;
        state.hasSidebar = !('sidebar' in route.query && route.query.sidebar==0) ;
    },
    [types.CHECK_GPDR_CONSENT](state) {
        state.hasGPDRConsent = state.isLocalstorageAvailable ? JSON.parse(localStorage.getItem(`cookie-settings-${state.route.query.key}`)) : false;
    },
    [types.SET_NETWORK_STATUS](state, status) {
        state.isOnline = status;
    },
    [types.SET_STARTED_WIDGET](state, widget) {
        state.startedWidget = widget;
    },
    [types.SET_PROTOCOL](state, protocol) {
        state.protocol = protocol;
    },
    [types.SET_LANGUAGE](state, language) {
        state.language = language;
    },
    [types.SET_INTERNAL_STATUS](state, status) {
        state.isInternal = status;
    },
    [types.SET_IFRAME_STATUS](state, status) {
        state.isIframe = status;
        let url = document.referrer ? new URL(document.referrer) : null;
        if (url && state.isIframe && [process.env.REVIEW_HABITEO_URL, process.env.PRESTA_HABITEO_URL].includes(url.hostname))
            state.isReviewUse = true;
    },
    [types.IS_COOKIES_ENABLED](state, status) {
        state.isCookiesEnabled = status;
    },
    [types.IS_LOCALSTORAGE_AVAILABLE](state, status) {
        state.isLocalstorageAvailable = status;
    },
    [types.TOGGLE_COOKIE_DISCLAIMER](state) {
        state.cookieDisclaimer.opened = !state.cookieDisclaimer.opened;
    },
    [types.SET_TRACKING_STATUS](state, data) {
        state.availableTrackings[data.provider] = data.status;
    },
    [types.SET_IS_LOADING](state, status) {
        state.isLoading = status;
    },
    [types.SET_LOGO](state, imageData) {
        if (state.logos === null)
            state.logos = {};
        state.logos[imageData.type] = imageData.src;
    },
    [types.SET_PROGRAM_INFO](state, programInfo) {
        state.programInfo = programInfo;
    },
    [types.SET_LOADING_BACKGROUND](state, img) {
        state.loadingBackground = img;
    },
    [types.SET_SNACKBAR](state, data) {
        state.snackbar = data;
    },
    [types.SET_DISABLE_CLOSE_SIDEBAR](state, data) {
        state.disableCloseSidebar = data;
    },
    [types.SET_RESOLUTION](state, resolution) {
        state.resolution = resolution;
    }
};

export default {
    state,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/app.js